import React from 'react';
import AboutHero from '../components/about/abouthero';
import AboutAbout from '../components/about/aboutabout';
import AboutVision from '../components/about/aboutvision';
import AboutGlobalFootprint from '../components/about/aboutglobalfootprint';
import AboutCta from '../components/about/aboutcta';
import Seo from '../components/seo/Seo';

const About: React.FC = () => {
  return (
    <main className="bg-black text-white">
      <Seo
        title="About Hogar Dorado House"
        description="Learn about Hogar Dorado House – a Dubai and USA-focused real estate investment house with a strategic global footprint and long-term investor partnerships."
        pathname="/about"
        keywords={[
          'Hogar Dorado House',
          'about Hogar Dorado',
          'real estate investment house',
          'Dubai property experts',
          'USA property experts',
          'America real estate experts',
          'Dubai and USA investment firm',
          'best real estate advisory Dubai',
          'trusted property advisors'
        ]}
      />
      <AboutHero />
      <AboutAbout />
      <AboutVision />
      <AboutGlobalFootprint />
      <AboutCta />
    </main>
  );
};

export default About;